import React from "react";
import Select, { ActionMeta, SingleValue } from "react-select";
import { Comparitor } from "../types";
import '../App.css'; // Make sure to import your CSS file

type ComparitorOption = {
  value: Comparitor;
  label: string;
};

interface CriteriaComparisonSelectorProps {
  currently_selected_comparitor: Comparitor | null;
  data_options: ComparitorOption[];
  handleComparisonChange: (newValue: SingleValue<ComparitorOption>, actionMeta: ActionMeta<ComparitorOption>) => void
}

const CriteriaComparisonSelector: React.FC<CriteriaComparisonSelectorProps> = ({ 
  data_options, 
  currently_selected_comparitor, 
  handleComparisonChange 
}) => {

  // Find the currently selected option that matches the comparitor
  const selectedOption = React.useMemo(() => {
    if (!currently_selected_comparitor) return null;
    const option = data_options.find(option => option.value === currently_selected_comparitor);
    return option || null;
  }, [data_options, currently_selected_comparitor]);

  return (
    <div className="criteria-input-container">
      <Select
        options={data_options}
        value={selectedOption}
        onChange={handleComparisonChange}
        placeholder="Select comparison method"
        className="criteria-react-select"
        classNamePrefix="criteria-select"
        menuPortalTarget={document.body} // This is the key addition - render menu in a portal
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Give menu portal a high z-index
          control: (provided) => ({
            ...provided,
            height: '38px',
            minHeight: '38px',
            borderColor: '#e2e8f0',
            boxShadow: 'none',
            '&:hover': {
              borderColor: '#cbd5e1',
            }
          }),
          valueContainer: (provided) => ({
            ...provided,
            padding: '2px 12px',
          }),
          singleValue: (provided) => ({
            ...provided,
            color: '#333',
          }),
          indicatorsContainer: (provided) => ({
            ...provided,
            height: '38px',
          }),
          dropdownIndicator: (provided) => ({
            ...provided,
            padding: '6px',
          }),
          clearIndicator: (provided) => ({
            ...provided,
            padding: '6px',
          }),
          placeholder: (provided) => ({
            ...provided,
            color: '#718096',
          }),
        }}
      />
    </div>
  );
};

export default CriteriaComparisonSelector;